import * as React from 'react'
import { MuiTextFieldFormik } from '@sales-center/components'
import { Field } from 'formik'
import { ActivityStatusOptions } from '../constants'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import MenuItem from '@mui/material/MenuItem'

export function StatusSelector() {
  return (
    <Stack>
      <Typography variant="body1" mt={1} fontSize={16}>
        Status
      </Typography>
      <Field
        component={MuiTextFieldFormik}
        disabled={false}
        fullWidth
        name="status"
        select
        size="small"
        label=""
        default="None"
        inputProps={{ 'data-test-id': 'status' }}
      >
        {ActivityStatusOptions.map((option) => (
          <MenuItem value={option.value} key={option.label}>
            {option.label}
          </MenuItem>
        ))}
      </Field>
    </Stack>
  )
}
